<template>
  <div class="">
    <div class="row my-3">


      <div class="col">
        <label>نام</label>
        <input type="text" v-model="form.properties.title" class="form-control">
      </div>

      <div class="col">
        <label>شرایط انتخاب</label>
        <select v-model="form.properties.select_status" class="custom-select">
          <option value="optional">اختیاری</option>
          <option value="required">اجباری</option>
        </select>
      </div>

    </div>

    <div class="">
      <div class="btn my-3 btn-primary" @click="createNewItem()">ایجاد ایتم جدید+</div>
      <div class="" v-for="item in form.items">
        <div class="row align-items-center text-center" v-if="item.show == true">
          <div class="col">
            <label>نام</label>
            <input type="text" class="form-control" v-model="item.name">
          </div>
          <div class="col">
            <label>قیمت</label>
            <input type="number" pattern="\d+" class="form-control" v-model="item.price">
          </div>
          <div class="col">
            <label>تخفیف</label>
            <input type="number" pattern="\d+" class="form-control" v-model="item.offer">
          </div>
          <div class="col">
            <b-icon-trash class="h3" @click="deleteOptionItem(item)"/>
          </div>
        </div>
      </div>
    </div>


    <div class="text-center">
      <div class="btn btn-primary my-3 rounded-pill w-75" @click="submitChangesToJson(form)">ثبت</div>
    </div>


  </div>
</template>

<script>
import {originalExtraOptionShape} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Reservation";

const generateRandomString = () => {
  return (
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15)
  );
}

export default {
  name: "ExtraOptionItem",
  props: {
    extraOptionItem: {
      default: null
    },
    extraOptions: {
      default: null
    }
  },
  data() {
    return {
      originalExtraOptionShape,
      form: {}
    }
  },
  methods: {
    generateRandomString,
    deleteOptionItem(item) {
      if (confirm('آیا از حذف ایتم اطمینان دارید؟')) {
        item.show = false
        this.$forceUpdate()
      }
    },
    createNewItem() {
      let originalExtraOptionShape = Object.assign({}, this.originalExtraOptionShape.item)
      originalExtraOptionShape.id = this.generateRandomString()
      this.form.items.push(originalExtraOptionShape)
      this.$forceUpdate()
    },
    formPropertiesChecker(form) {
      let originalExtraOptionShape = this.originalExtraOptionShape.properties
      Object.entries(originalExtraOptionShape).forEach(item => {
        const key = item[0]
        const value = item[1]
        if (Object.keys(form.properties).indexOf(key) === -1) {
          form.properties[key] = value
        }
      })
    },
    formItemsChecker(form) {
      let originalExtraOptionShape = this.originalExtraOptionShape.item
      Object.entries(originalExtraOptionShape).forEach(item => {
        const key = item[0]
        const value = item[1]
        form.items.forEach(item => {
          if (Object.keys(item).indexOf(key) === -1) {
            item[key] = value
          }
        })
      })
    },
    updateMode() {
      return this.extraOptionItem != null
    },
    submitChangesToJson(form) {
      if (this.updateMode()) { // if we are in update mode first remove old items and then remove the new
        let index = this.extraOptions.findIndex(function (obj) {
          return obj.id === form.id;
        });

        this.extraOptions.splice(index, 1);
      }
      this.extraOptions.push(form)
      this.$emit('refresh', true)
    },
  },
  beforeMount() {
    if (this.updateMode()) {
      this.form = this.extraOptionItem
    } else {
      // set default keys
      this.form.id = this.generateRandomString()
      this.form.properties = {}
      this.form.items = [{}]
    }
    this.formPropertiesChecker(this.form)
    this.formItemsChecker(this.form)
  }
}
</script>


<style scoped>

</style>